import { render } from "./ManageGames.vue?vue&type=template&id=af7f7e36"
import script from "./ManageGames.vue?vue&type=script&lang=js"
export * from "./ManageGames.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__